import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"

export const useUpdateGrade = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updateGrade(data),
		onError: err => console.log(err),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Цена за урок обновлена')
    },
  })

	return mutation
}